import { ZERO } from '@/constants/common';
import Icon from 'ol/style/Icon';
import Style from 'ol/style/Style';
import { getPinSize } from '@/constants/canvas';
import { getCanvasIcon } from '../getCanvasIcon';

export const getCommentPinStyle = ({
  value,
  color,
  textColor,
}: {
  value?: number;
  color: string;
  textColor?: string;
}): Style =>
  new Style({
    image: new Icon({
      displacement: [ZERO, getPinSize('comment').height],
      anchorXUnits: 'fraction',
      anchorYUnits: 'pixels',
      img: getCanvasIcon({
        color,
        value,
        textColor,
        pinIcon: 'comment',
      }),
    }),
  });
